<div class="theme-container" [responsiveBackgroundImage]="backgroundImage">
  <div class="overlay"></div>
  <div class="tagline-container">
    <div [ngClass]="backgroundImage ? 'image custom-image' : 'image'">
      <h1>{{ headingCopy }}</h1>
      <div class="action-tag tagline">{{ subHeadingCopy }}</div>
      <div class="action-tag tagline">{{ subHeadingSecondCopy }}</div>
    </div>
  </div>

  <div class="article">
    <article *ngIf="offerSet">

      <div *ngIf="offerSet.group" class="options" [class.has-3-options]="offerSet.offers.length === 3">
        <div class="option" *ngFor="let offerGroup of offersGroups">
          <div class="action">
            <div class="period-tab">
              <a *ngIf="offerGroup.group[0].period === 'monthly'" href="javascript:;" (click)="selectOfferTab(offerGroup.groupIndex, 0)" class="period-month {{offerGroup.selected == 0 ? '': 'stand-by'}}" >Monthly</a>
              <a *ngIf="offerGroup.group.length === 2 || offerGroup.group[0].period === 'annually'" href="javascript: ;" (click)="selectOfferTab(offerGroup.groupIndex, 1)" class="period-year {{offerGroup.selected == 1 || offerGroup.group[0].period === 'annually' ? '': 'stand-by'}}">Yearly</a>
            </div>
            <div class="tag">TYT <app-plus-tag></app-plus-tag> {{offerGroup.group[offerGroup.selected].title}}</div>
            <div [innerHTML]="offerGroup.group[offerGroup.selected].benefits | trustHtml" class="offer-benefits"></div>
            <div class="price">
              <span *ngIf="offerGroup.group[offerGroup.selected].dollar_price > 0">
                <span class="amount">{{offerGroup.group[offerGroup.selected].dollar_price | currency:'USD':true}}</span>
                <span class="amount-cycle"> /{{offerGroup.group[offerGroup.selected].period === 'monthly' ? 'month': 'year'}}</span>
              </span>
              <span *ngIf="offerGroup.group[offerGroup.selected].price == 0">
                FREE
              </span>
            </div>
            <div class="cycle">Billed Automatically</div>
            <div class="join">
              <div class="space-unused"></div>
              <a class="c2a-btn" *ngIf="user" routerLink="/payment/{{offerSet.uuid}}/{{offerGroup.group[offerGroup.selected].uuid}}">
                {{ offerGroup.group[0].action_text }}
                <div class="side-icon">
                  <i class="fas fa-arrow-right"></i>
                </div>
              </a>
              <a class="c2a-btn" *ngIf="!user" routerLink="/signup/{{offerSet.uuid}}/{{offerGroup.group[offerGroup.selected].uuid}}">
                {{ offerGroup.group[0].action_text }}
                <div class="side-icon">
                  <i class="fas fa-arrow-right"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!offerSet.group" class="options" [class.has-3-options]="offerSet.offers.length === 3">
        <div class="option" *ngFor="let offer of offerSet.offers; index as i" [attr.data-shutter-order]="i">
          <div class="action">
            <div class="tag">TYT <app-plus-tag></app-plus-tag> {{offer.title}}</div>
            <div class="price">
              <span *ngIf="offer.dollar_price > 0">
                <span class="amount">{{offerPrice(offer)| currency:'USD':true}}</span>
                <span class="amount-cycle">/{{offer.period === 'monthly' ? 'month': 'year'}}</span>
              </span>
              <span *ngIf="offer.price == 0">
                FREE
              </span>
            </div>
            <div class="cycle">Billed Automatically</div>
            <div [innerHTML]="offer.benefits | trustHtml" class="offer-benefits"></div>
            <div class="view-dual" *ngIf="offer.kind === 'dual'">
              <a [routerLink]="showAlternateOffer(offer.uuid)">{{viewOfferText(offer)}}</a>
            </div>
            <div class="join">
              <div class="space-unused"></div>
              <a class="c2a-btn" *ngIf="user" routerLink="/payment/{{offerSet.uuid}}/{{offer.uuid}}">
                {{ offer.action_text }}
                <div class="side-icon">
                  <i class="fas fa-arrow-right"></i>
                </div>
              </a>
              <a class="c2a-btn" *ngIf="!user" routerLink="/signup/{{offerSet.uuid}}/{{offer.uuid}}">
                {{ offer.action_text }}
                <div class="side-icon">
                  <i class="fas fa-arrow-right"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="links">
        <div *ngIf="offerSet.link_text && offerSet.link_url">
          <a class="btn-additional" href="{{offerSet.link_url}}">
            {{offerSet.link_text}}
            <div class="side-icon">
              <i class="fas fa-arrow-right"></i>
            </div>
          </a>
          <br/><br/>
        </div>
        By signing up via any of the above methods, you agree to TYT's
        <a class="terms-link" target="_blank" routerLink="/terms"> Terms of Use, </a>
        <a class="terms-link" target="_blank" routerLink="/privacy"> Privacy Policy</a>
        and
        <a class="terms-link" target="_blank" routerLink="/core-values"> Core Values.</a>
      </div>
    </article>
  </div>
</div>
